import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/lib/auth';
import { applyMotionPreference } from '@/lib/motion';
import { registrarServiceWorker } from '@/lib/pwa';
import { App } from './App';
import './styles/theme.css';

applyMotionPreference();
registrarServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Placar e classificação envelhecem rápido durante a rodada, mas não
      // tanto a ponto de justificar refetch a cada foco de janela.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root não encontrado.');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
